<template>
  <div>
    <el-tabs value="tab_pannel" type="border-card" v-model="activeName">
      <el-tab-pane label="企业管理" name="tab_1">
        <el-form ref="form" :model="formQuery" inline size="mini">

          <el-form-item label="企业ID：">
            <el-input v-model="formQuery.qiyeId"></el-input>
          </el-form-item>

          <el-form-item label="企业名字：">
            <el-input v-model="formQuery.qiyeName"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click.native.prevent="()=>{formVisible=true, isEdit=false}">添加企业
            </el-button>

            <el-button type="primary" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>


        <el-table :data="List" size="mini">
          <el-table-column type="expand">
            <template v-slot:="scope">
              <el-form label-position="left" inline class="demo-table-expand" size="mini">

                <el-form-item v-for="item in scope.row.pic" :key="item.name" :label="item.name">
                  <template>
                    <img :src="item.url" width="50" height="50" class="tableImg"/>
                  </template>
                </el-form-item>
              </el-form>

              <el-table-column type="expand">
                <template v-slot:="scope">
                  <vue-json-editor v-model="scope.row" :showBtns="true"></vue-json-editor>
                </template>
              </el-table-column>

            </template>
          </el-table-column>
          <el-table-column label="企业ID" prop="_id" width="150"/>
          <el-table-column label="企业名字" prop="name" width="200"/>
          <el-table-column label="状态" prop="state" width="80">
            <template v-slot:="scope">
              <el-tag :type="getActiveStateTagInfo(scope.row.state).tag">{{
                  getActiveStateTagInfo(scope.row.state).label
                }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="支付方式" prop="payTypeStr" width="200"/>
          <el-table-column label="销售渠道" prop="saleChannelStr" width="100"/>
          <el-table-column label="投诉电话" prop="phone" width="80"/>
          <el-table-column label="企业介绍" prop="info" width="200"/>
          <el-table-column label="主企业" prop="masterqiye" width="200"/>
          <el-table-column label="操作" width="400">
            <template v-slot:="scope">
              <el-button style="margin-left: 10px;"
                         size="mini"
                         @click="handleEditVisible(scope.$index, scope.row)">编辑
              </el-button>
              <el-button style="margin-left: 10px;"
                         size="mini"
                         @click="handleAttachProductVisible(scope.row)">分配保险产品
              </el-button>
              <el-button style="margin-left: 10px;"
                         size="mini"
                         type="warning"
                         @click="handleChangeState(1, scope.row)">冻结
              </el-button>
              <el-button style="margin-left: 10px;"
                         size="mini"
                         @click="handleChangeState(0, scope.row)">还原
              </el-button>
              <el-button style="margin-left: 10px;"
                         size="mini"
                         type="danger"
                         @click="handleDelete(scope.$index, scope.row)">删除
              </el-button>

              <el-button style="margin-left: 10px;"
                         size="mini"
                         type="danger"
                         @click="handleBlackListVisible(scope.$index, scope.row)">黑名单
              </el-button>

              <el-button style="margin-left: 10px;"
                         size="mini"
                         type="danger"
                         @click="handleSubListVisible(scope.$index, scope.row)">相关企业（子）
              </el-button>

            </template>
          </el-table-column>
        </el-table>

        <el-pagination
            ref="pagination"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            @size-change="handleSizeChange"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalSize">
        </el-pagination>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="企业信息" :visible.sync="formVisible" :close-on-click-modal="false">
      <el-form ref="form" :model="form" size="mini">
        <el-form-item label="企业ID：">
          <el-input v-model="form._id"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>
        <el-form-item label="企业名字：">
          <el-input v-model="form.name"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>
        <el-form-item label="投诉电话：">
          <el-input v-model="form.phone"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>
        <el-form-item label="支付方式：">
          <el-select
              v-model="form.payTypeList"
              multiple
              filterable
              allow-create
              default-first-option
              placeholder="选择支付方式">
            <el-option
                v-for="item in optPayType"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="销售渠道：">
          <el-select
              v-model="form.saleChannelList"
              multiple
              filterable
              allow-create
              default-first-option
              placeholder="选择销售渠道">
            <el-option
                v-for="item in optSaleChannelType"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所属主体：">
          <el-select
              v-model="form.saleEntityList"
              multiple
              filterable
              default-first-option
              placeholder="选择所属主体">
            <el-option
                v-for="item in optSaleEntity"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="企业信息：">
          <el-input v-model="form.info"
                    type="textarea"
                    autosize
          ></el-input>
        </el-form-item>

        <el-form-item label="extra：">
          <vue-json-editor v-model="form.extra" :showBtns="true"></vue-json-editor>
        </el-form-item>

        <el-form-item label="小票自定义文字：">
          <el-input v-model="form.qrinfo"
                    type="textarea"
                    autosize
          ></el-input>
        </el-form-item>

        <el-form-item label="图片">
          <file-upload ref="fileUpload" v-model="fileList"></file-upload>
        </el-form-item>

        <el-checkbox v-model="form.canUnlock">锁屏开关</el-checkbox>
        <el-checkbox v-model="form.canQuery">查询开关</el-checkbox>
        <el-checkbox v-model="form.canSwitchApplicantToQiYe">切换企业投保开关</el-checkbox>
        <el-checkbox v-model="form.canPreplace">预出单开关</el-checkbox>
        <el-checkbox v-model="form.shutReceipt">关闭小票留底</el-checkbox>
        <el-checkbox v-model="form.isWithEN">启动英文版本</el-checkbox>
        <el-checkbox v-model="form.canSendAirport">回传机场开关</el-checkbox>

        <el-form-item label="上传机场权重：">
          <el-input v-model="form.sendAirportWeight"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>

        <el-form-item label="投保人企业名称：">
          <el-input v-model="form.applicantQiYeName"
                    type="textarea"
                    autosize
          ></el-input>
        </el-form-item>
        <el-form-item label="投保人企业Code：">
          <el-input v-model="form.applicantQiYeCode"
                    type="textarea"
                    autosize
          ></el-input>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false" @click.native.prevent="handleCancel">取 消</el-button>
        <template v-if="!isEdit">
          <el-button type="primary" @click.native.prevent="handleAdd">添加</el-button>
        </template>
        <template v-else>
          <el-button type="primary" @click.native.prevent="handleEdit">编辑</el-button>
        </template>
      </div>
    </el-dialog>

    <el-dialog title="黑名单" :visible.sync="formBlackListVisible" :close-on-click-modal="false" width="60%">
      <el-input v-model="formBlackListData.ssBlackList"
                type="textarea"
                autosize></el-input>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleBlackList">分配</el-button>
      </div>

    </el-dialog>


    <el-dialog title="相关企业（子）" :visible.sync="formSubListVisible" :close-on-click-modal="false" width="60%">
      <el-input v-model="formSubListData.subList"
                type="textarea"
                autosize></el-input>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubkList">分配</el-button>
      </div>

    </el-dialog>

    <el-dialog title="分配保险信息" :visible.sync="formAttachVisible" :close-on-click-modal="false" width="80%">
      <div style="display: flex; gap: 16px;">
        <!-- 左侧：可选产品 -->
        <div style="flex: 1; border: 1px solid #ebeef5; border-radius: 4px; padding: 10px;">
          <div style="margin-bottom: 8px; font-weight: bold;">可选产品</div>
          <el-input v-model="attachSearchKey" placeholder="搜索产品名/保司名/ID" size="mini" clearable
                    style="margin-bottom: 8px;"></el-input>
          <div style="max-height: 400px; overflow-y: auto;">
            <div v-for="item in filteredAvailableProducts" :key="item._id"
                 style="display: flex; align-items: center; justify-content: space-between; padding: 6px 8px; border-bottom: 1px solid #f0f0f0;">
              <span style="font-size: 12px; word-break: break-all; flex: 1;">{{ item._id }} | {{ item.name }}（{{ item.baosiName }}）</span>
              <el-button size="mini" type="primary" icon="el-icon-right"
                         style="margin-left: 8px; flex-shrink: 0;"
                         @click="addToAttached(item)">添加</el-button>
            </div>
            <div v-if="!filteredAvailableProducts.length" style="text-align: center; color: #999; padding: 20px;">
              无匹配产品
            </div>
          </div>
        </div>
        <!-- 右侧：已分配产品（拖拽排序） -->
        <div style="flex: 1; border: 1px solid #ebeef5; border-radius: 4px; padding: 10px;">
          <div style="margin-bottom: 8px; font-weight: bold;">已分配产品（{{ attachedProducts.length }}）<span style="font-size: 11px; color: #999; margin-left: 8px;">拖拽排序即优先级</span></div>
          <el-input v-model="attachedSearchKey" placeholder="搜索已分配产品" size="mini" clearable
                    style="margin-bottom: 8px;"></el-input>
          <div style="max-height: 400px; overflow-y: auto;">
            <div v-for="(item, index) in filteredAttachedProducts" :key="item._id"
                 draggable="true"
                 @dragstart="onDragStart(item, $event)"
                 @dragover.prevent="onDragOver(item, $event)"
                 @drop="onDrop(item)"
                 @dragend="dragItem = null"
                 :style="{
                   display: 'flex', alignItems: 'center', padding: '6px 8px',
                   borderBottom: '1px solid #f0f0f0', cursor: attachedSearchKey ? 'default' : 'move',
                   background: dragOverItem === item._id ? '#ecf5ff' : 'transparent'
                 }">
              <span style="font-size: 12px; color: #409EFF; margin-right: 6px; flex-shrink: 0;">{{ getAttachedIndex(item) + 1 }}.</span>
              <span style="font-size: 12px; word-break: break-all; flex: 1;">{{ item._id }} | {{ item.name }}（{{ item.baosiName }}）</span>
              <el-button size="mini" type="danger" icon="el-icon-delete"
                         style="margin-left: 8px; flex-shrink: 0;"
                         @click="removeFromAttached(item._id)"></el-button>
            </div>
            <div v-if="!filteredAttachedProducts.length" style="text-align: center; color: #999; padding: 20px;">
              暂无匹配产品
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="formAttachVisible = false">取消</el-button>
        <el-button type="primary" @click="handleAttachProduct">分配</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import * as _ from 'lodash';
import VueJsonEditor from '@/components/VueJsonEditor'
import FileUpload from '@/components/FileUpload'
import {
  getActiveStateTagInfo,
  getSaleEntity, OptsPayType, OptsSaleChannel, getOptsList, OptSaleEntity
} from '@/utils'
import {SaleChannel, SaleEntityType, getPayTypeDesc, getSaleChannelDesc} from "@/utils/constants";

export default {
  data() {
    return {
      activeName: 'tab_1',
      form: {
        name: "",
        info: "",
        pic: [],
        _id: "",
        phone: "",
        payTypeList: [],
        saleChannelList: [],
        saleEntityList: [],
        extra: {},
        qrinfo: '',
        canUnlock : false,
        canQuery : false,
        canSwitchApplicantToQiYe : false,
        canPreplace : false,
        isWithEN : false,
        canSendAirport : false,
        sendAirportWeight : 0,
        shutReceipt : false,
        applicantQiYeName : '',
        applicantQiYeCode : '',
      },

      searchBaoSi: '',

      List: [],
      currentPage: 1,
      pageSize: 10,
      totalSize: 0,
      formVisible: false,

      formQuery: {
        qiyeName: "",
        qiyeId: "",
      },

      //展开列表显示商品信息
      qiyeProduct: {},

      formAttachQuery: {
        baosiName: "",
        productName: "",
        state: [],
        type: 0,
        qiyeId: "",
      },
      productList: [],
      attachedProducts: [],
      attachSearchKey: '',
      attachedSearchKey: '',
      dragItem: null,
      dragOverItem: null,
      formAttachVisible: false,
      formAttach: {
        qiye: null,
      },
      formBlackListData: {
        ssBlackList: '',
        qiyeId: "",
      },
      formBlackListVisible: false,


      formSubListData: {
        subList: '',
        qiyeId: "",
      },
      formSubListVisible: false,

      extra: {
        validDays: 0,
        premium: 0,
        needFlightInfo: false,
      },

      isEdit: false,
      optPayType: OptsPayType,
      optSaleChannelType: getOptsList(OptsSaleChannel, SaleChannel.App | SaleChannel.H5),
      optSaleEntity: _.filter(OptSaleEntity, (item) => item.value !== SaleEntityType.None),
      getActiveStateTagInfo,
      getSaleEntity,
      fileList: [],
    }
  },
  computed: {
    filteredAvailableProducts() {
      const attachedIds = new Set(this.attachedProducts.map(p => p._id));
      const q = (this.attachSearchKey || '').toLowerCase();
      return this.productList.filter(p => {
        if (attachedIds.has(p._id)) return false;
        if (!q) return true;
        return (p.name || '').toLowerCase().includes(q)
            || (p.baosiName || '').toLowerCase().includes(q)
            || (p._id || '').toLowerCase().includes(q)
            || (p.baosiId || '').toLowerCase().includes(q);
      });
    },
    filteredAttachedProducts() {
      const q = (this.attachedSearchKey || '').toLowerCase();
      if (!q) return this.attachedProducts;
      return this.attachedProducts.filter(p => {
        return (p.name || '').toLowerCase().includes(q)
            || (p.baosiName || '').toLowerCase().includes(q)
            || (p._id || '').toLowerCase().includes(q)
            || (p.baosiId || '').toLowerCase().includes(q);
      });
    }
  },
  methods: {

    handleSizeChange: function (val) {
      this.pageSize = val;
    },

    query: function (offset) {
      let params = {
        qiyeName: this.formQuery.qiyeName,
        qiyeId: this.formQuery.qiyeId,
        limit: this.pageSize,
        offset
      }
      this.$axios.post('/qiye/list', params).then(res => {
        this.$message.info('查询企业成功');

        this.List = res.qiye;
        this.List.forEach(item => {
          item["payTypeList"] = _.map(getOptsList(OptsPayType, item.payType), (v) => v.value);
          item["payTypeStr"] = getPayTypeDesc(item.payType);
          item["saleChannelStr"] = getSaleChannelDesc(item.saleChannel);
          item["saleChannelList"] = _.map(getOptsList(OptsSaleChannel, item.saleChannel), (v) => v.value);
          // item["blackList"] = _.map(getOptsList(OptsSaleChannel, item.saleChannel), (v) => v.value);
        })
        this.totalSize = res.count;
      }).catch(res => {
      })
    },

    handleCurrentChange: function (val) {
      this.query((val - 1) * this.pageSize);
    },

    handleQuery: function (row, val) {
      this.query(0);
      this.currentPage = 1;
    },

    handleEditVisible: function (index, row) {
      this.form = {
        name: row.name,
        info: row.info,
        pic: row.pic,
        _id: row._id,
        phone: row.phone,
        payType: row.payType,
        payTypeList: row.payTypeList,
        saleChannelList: row.saleChannelList,
        saleEntityList: row.saleEntityList || [],
        extra: row.extra || {},
        qrinfo: row.qrinfo || '',
        canUnlock: row.canUnlock,
        canQuery: row.canQuery,
        canSwitchApplicantToQiYe: row.canSwitchApplicantToQiYe,
        canPreplace: row.canPreplace,
        isWithEN: row.isWithEN,
        canSendAirport: row.canSendAirport,
        sendAirportWeight: row.sendAirportWeight,
        shutReceipt: row.shutReceipt,
        applicantQiYeName: row.applicantQiYeName,
        applicantQiYeCode: row.applicantQiYeCode,
      }
      this.formVisible = true;
      this.isEdit = true;
      this.$nextTick(() => {
        this.$refs.fileUpload.loadFiles(row.pic || {});
      });
    },

    handleEdit: async function (index, row) {
      let params = {
        name: this.form.name,
        info: this.form.info,
        files: await this.$refs.fileUpload.getFiles(),
        qiyeId: this.form._id,
        phone: this.form.phone,
        payType: _.sum(this.form.payTypeList),
        saleChannel: _.sum(this.form.saleChannelList),
        saleEntityList: this.form.saleEntityList,
        extra: this.form.extra,
        qrinfo: this.form.qrinfo,
        canUnlock: this.form.canUnlock,
        canQuery: this.form.canQuery,
        canSwitchApplicantToQiYe: this.form.canSwitchApplicantToQiYe,
        canPreplace: this.form.canPreplace,
        isWithEN: this.form.isWithEN,
        canSendAirport: this.form.canSendAirport,
        sendAirportWeight: this.form.sendAirportWeight,
        shutReceipt: this.form.shutReceipt,
        applicantQiYeName: this.form.applicantQiYeName,
        applicantQiYeCode: this.form.applicantQiYeCode,
      };
      this.$axios.post('/qiye/update', params).then(res => {
        this.$message.info('修改企业成功');
      }).catch(res => {
      })
      this.formVisible = false;
      this.resetform();
    },

    handleDelete: function (index, row) {
      // console.log(`即将删除：${JSON.stringify(row)}`);
      this.$confirm("确认删除企业？", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "red"
      }).then(() => {
        let params = {
          qiyeId: row._id,
        }
        this.$axios.post('/qiye/delete', params).then(res => {
          this.$message.info('删除企业成功');
        }).catch(res => {
        })

      }).catch(() => {
      })

    },

    async handleAdd() {
      let params = {
        name: this.form.name,
        info: this.form.info,
        files: await this.$refs.fileUpload.getFiles(),
        qiyeId: this.form._id,
        phone: this.form.phone,
        payType: _.sum(this.form.payTypeList),
        saleChannel: _.sum(this.form.saleChannelList),
        saleEntityList: this.form.saleEntityList,
        extra: this.form.extra,
        qrinfo: this.form.qrinfo,
        canUnlock: this.form.canUnlock,
        canQuery: this.form.canQuery,
        canSwitchApplicantToQiYe: this.form.canSwitchApplicantToQiYe,
        canPreplace: this.form.canPreplace,
        isWithEN: this.form.isWithEN,
        canSendAirport: this.form.canSendAirport,
        sendAirportWeight: this.form.sendAirportWeight,
        shutReceipt: this.form.shutReceipt,
        applicantQiYeName: this.form.applicantQiYeName,
        applicantQiYeCode: this.form.applicantQiYeCode,
      };
      this.$axios.post('/qiye/create', params).then(res => {
        this.$message.info('上传企业成功');
      }).catch(res => {
      })
      this.formVisible = false;
      this.resetform();
    },

    handleBlackListVisible: function (index, row) {
      // console.log(`handleBlackListVisible：${JSON.stringify(row)}`);
      this.formBlackListData.ssBlackList = _.join(row.blackList || [], '\n');
      this.formBlackListData.qiyeId = row._id;
      this.formBlackListVisible = true;
    },

    handleBlackList: function (index, row) {
      let params = {
        qiyeId: this.formBlackListData.qiyeId,
        blackList: _.split(this.formBlackListData.ssBlackList, '\n'),
      };
      this.$axios.post('/qiye/update', params).then(res => {
        this.$message.info('修改企业黑名单成功');

      }).catch(res => {
        // console.log(res);
      }).finally(() => {
        this.formBlackListVisible = false;
        this.formBlackListData.ssBlackList = '';
        this.formBlackListData.qiyeId = '';
      })
    },

    //相关企业管理（子）
    handleSubListVisible: function (index, row) {
      // console.log(`handleSubListVisible：${JSON.stringify(row)}`);
      this.formSubListData.subList = _.join(row.subList || [], '\n');
      this.formSubListData.qiyeId = row._id;
      this.formSubListVisible = true;
    },

    handleSubkList: function (index, row) {
      let params = {
        qiyeId: this.formSubListData.qiyeId,
        subList: this.formSubListData.subList.length > 0 ? _.split(this.formSubListData.subList, '\n') : [],
      };

      this.$axios.post('/qiye/update', params).then(res => {
        this.$message.info('修改相关企业成功');

      }).catch(res => {
      }).finally(() => {
        this.formSubListVisible = false;
        this.formSubListData.subList = '';
        this.formBlackListData.qiyeId = '';
      })
    },

    handleCancel: function () {
      this.formVisible = false;
      this.resetform();
    },

    resetform: function () {
      this.form = {
        name: "",
        info: "",
        pic: [],
        _id: "",
        phone: "",
        payTypeList: [],
        saleChannelList: [],
        saleEntityList: [],
        extra: {},
        qrinfo: '',
        canUnlock: false,
        canQuery: false,
        canSwitchApplicantToQiYe: false,
        canPreplace: false,
        isWithEN: false,
        canSendAirport: false,
        sendAirportWeight: 0,
        shutReceipt: false,
        applicantQiYeName: '',
        applicantQiYeCode: '',
      }
    },

    handleChangeState(state, row) {
      let params = {
        qiyeId: row._id,
        state
      };
      this.$axios.post('/qiye/update', params).then(res => {
        this.$message.info('更新企业成功');
      }).catch(res => {
      })
    },

    async handleAttachProductVisible(row) {
      this.formAttachQuery.qiyeId = row._id;
      this.formAttach.qiye = row;
      this.attachSearchKey = '';
      await this.handleQueryProduct();
      this.formAttachVisible = true;
    },

    handleAttachProduct() {
      // 按拖拽顺序设置优先级
      const products = this.attachedProducts.map((p, index) => ({
        ...p,
        priority: index + 1,
      }));
      let params = {
        qiye: this.formAttach.qiye,
        products
      };
      this.$axios.post('/product/qiye/attach', params).then(res => {
        this.$message.info('企业绑定商品成功');
      }).catch(res => {
      })
    },

    addToAttached(product) {
      this.attachedProducts.push({
        ...product,
        priority: this.attachedProducts.length + 1,
      });
    },

    removeFromAttached(id) {
      const index = this.attachedProducts.findIndex(p => p._id === id);
      if (index !== -1) this.attachedProducts.splice(index, 1);
    },

    onDragStart(item, event) {
      if (this.attachedSearchKey) {
        event.preventDefault();
        return;
      }
      this.dragItem = item;
      event.dataTransfer.effectAllowed = 'move';
    },

    onDragOver(item, event) {
      if (this.attachedSearchKey) return;
      this.dragOverItem = item._id;
    },

    onDrop(targetItem) {
      if (!this.dragItem || this.dragItem._id === targetItem._id || this.attachedSearchKey) {
        this.dragOverItem = null;
        return;
      }
      const fromIndex = this.attachedProducts.findIndex(p => p._id === this.dragItem._id);
      const toIndex = this.attachedProducts.findIndex(p => p._id === targetItem._id);
      if (fromIndex === -1 || toIndex === -1) return;
      const [moved] = this.attachedProducts.splice(fromIndex, 1);
      this.attachedProducts.splice(toIndex, 0, moved);
      this.dragItem = null;
      this.dragOverItem = null;
    },

    getAttachedIndex(item) {
      return this.attachedProducts.findIndex(p => p._id === item._id);
    },

    async handleQueryProduct() {
      this.productList = [];
      this.attachedProducts = [];
      let params = {
        qiyeId: this.formAttachQuery.qiyeId,
        limit: 1000,
        offset: 0,
        needAll: true,
      }
      this.$axios.post('/product/list', params).then(res => {
        this.$message.info('查询商品成功');
        const ownProductList = res.product || [];
        const allProductList = res.all || [];

        // 所有产品作为左侧可选列表
        this.productList = allProductList;

        // 已分配的产品作为右侧列表（带优先级）
        this.attachedProducts = ownProductList.map(p => ({
          ...p,
          priority: p.priority || 1000,
        }));
        // 按优先级排序
        this.attachedProducts.sort((a, b) => a.priority - b.priority);
      }).catch(res => {
      })
    },
  },

  watch: {},

  created() {
  },

  updated() {
    // this.toggleSelection();
  },

  components: {VueJsonEditor, FileUpload},
}
</script>

<style scoped>
</style>
